import React, { Component } from 'react';
import { Outlet } from 'react-router';
import ErrorBoundary from '../Error/ErrorBoundary';

class Layout extends Component {
  render () {
    return (
        <ErrorBoundary>
            <Outlet />
        </ErrorBoundary>
    );
  }
}

export default Layout;